import { GETEmployeeSkillsResponse, ISupportEmployee } from '@cbgms/api'
import { EmailOptions } from '@cbgms/api/modules/enums'

export const getOptions = (response: GETEmployeeSkillsResponse) => {
  return response.Data.map(item => ({
    key: item.EmployeeSkill.UUID,
    value: item.EmployeeSkill.UUID,
    text: item.EmployeeSkill.Title
  }))
}

export const defaultUserEmailOption = (initialValues: ISupportEmployee) => {
  if (initialValues.EmailAddressWork) {
    return EmailOptions.Work
  }

  return EmailOptions.Other
}

export const defaultUserEmail = (formValues: ISupportEmployee, initialValues: ISupportEmployee, selectedOption: EmailOptions): string => {
  switch (selectedOption) {
    case EmailOptions.Work:
      return (formValues && formValues.EmailAddressWork) || initialValues.EmailAddressWork
    default:
      return ''
  }
}
